
import React from 'react';
import HeaderSection from '@/components/portfolio/HeaderSection';
import PortfolioList from '@/components/portfolio/PortfolioList';
import { FilterOptions } from '@/components/FilterModal';
import { Portfolio } from '@/schemas/portfolio'; // Updated import
import { Business } from '@/schemas/business';   // Added import for Business type
import { LayoutMode } from '@/hooks/usePortfolioState';
import { cn } from '@/lib/utils';

interface PortfolioPageLayoutProps {
  allBusinesses: Business[]; // Added allBusinesses prop
  searchTerm: string;
  filters: FilterOptions;
  layoutMode: LayoutMode;
  setLayoutMode: (mode: LayoutMode) => void;
  showMobileSearch: boolean;
  setShowMobileSearch: (show: boolean) => void;
  showFilterButton: boolean;
  setShowFilterButton: (show: boolean) => void;
  showFilterOptions: boolean;
  setShowFilterOptions: (show: boolean) => void;
  onSearch: (term: string) => void;
  onFilterChange: (filters: FilterOptions) => void;
  onFilterApply: () => void;
  onAddNewPortfolio: () => void;
  onSelectPortfolio: (portfolioId: string) => void;
  onShowMobileAddBusinessModal: () => void;
  allPortfolios: Portfolio[];
  filteredPortfolios: Portfolio[];
  toggleFilterOptions: () => void;
}

const PortfolioPageLayout: React.FC<PortfolioPageLayoutProps> = ({
  allBusinesses, // Destructure allBusinesses
  searchTerm,
  filters,
  layoutMode,
  setLayoutMode,
  showMobileSearch,
  setShowMobileSearch,
  showFilterButton,
  setShowFilterButton,
  showFilterOptions,
  setShowFilterOptions,
  onSearch,
  onFilterChange,
  onFilterApply,
  onAddNewPortfolio,
  onSelectPortfolio,
  onShowMobileAddBusinessModal,
  allPortfolios,
  filteredPortfolios,
  toggleFilterOptions
}) => {
  return (
    <main className="flex-1 max-w-screen-xl mx-auto px-0 md:px-8 py-0 w-full animate-fade-in">
      <HeaderSection
        searchTerm={searchTerm}
        filters={filters}
        layoutMode={layoutMode}
        setLayoutMode={setLayoutMode}
        showMobileSearch={showMobileSearch}
        setShowMobileSearch={setShowMobileSearch}
        showFilterButton={showFilterButton}
        setShowFilterButton={setShowFilterButton}
        showFilterOptions={showFilterOptions}
        setShowFilterOptions={setShowFilterOptions}
        onSearch={onSearch}
        onFilterChange={onFilterChange}
        onFilterApply={onFilterApply}
        onAddNewPortfolio={onAddNewPortfolio}
        onSelectPortfolio={onSelectPortfolio}
        onShowMobileAddBusinessModal={onShowMobileAddBusinessModal}
        allPortfolios={allPortfolios}
        filteredPortfolios={filteredPortfolios}
        toggleFilterOptions={toggleFilterOptions}
      />
      
      <PortfolioList
        allBusinesses={allBusinesses} // Pass allBusinesses
        filteredPortfolios={filteredPortfolios}
        searchTerm={searchTerm}
        filters={filters}
        layoutMode={layoutMode}
        setSearchTerm={onSearch}
        setFilters={onFilterChange}
        setShowMobileSearch={setShowMobileSearch}
        setShowFilterButton={setShowFilterButton}
        setShowFilterOptions={setShowFilterOptions}
        showFilterOptions={showFilterOptions}
        onAddNewPortfolio={onAddNewPortfolio}
        className="mt-3"
      />
    </main>
  );
};

export default PortfolioPageLayout;
